<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button class="md-simple md-just-icon md-just-icon-small" @click="editItem" :disabled="!allowEdit">
				<i class="fa font_lg fa-pencil secondary_color"></i>
			</md-button>
		</div>
		<div class="operation_item">
			<md-button class="md-simple md-just-icon md-just-icon-small" @click="deleteItem" :disabled="!allowDelete">
				<i class="fa font_lg fa-trash-o secondary_color"></i>
			</md-button>
		</div>
	</div>
</template>
<script>

import {isValueSet} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	data() {
		return { };
	},
	methods: {
		editItem() {
			this.params.editFun(this.params.data);
		},
		deleteItem() {
			this.params.delFun(this.params.data);
		}
	},
	computed: {
		allowEdit() {
			// todo installment now: add any other conditions
			return this.changeable;
		},
		allowDelete() {
			// todo installment now: add any other conditions
			let { data } = this.params;
			return enumDef.receivableStatus.isDeletable(data.status) && !isValueSet(data.opportunityStatus) && !data.convertedFromUpcomingOpportunity
		},
		changeable() {
			let { data } = this.params;
			// When adding new contract item details might be empty, so changing is always allowed then
			if (!isValueSet(data.id)) {
				return true;
			}
			// todo installment now: add any other conditions
			return enumDef.receivableStatus.isChangeable(data.status);
		},
	}
};
</script>
